var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',[_vm._v("Comprendre les gammes avec les degrés relatifs")]),_c('iframe',{staticClass:"mystyle",attrs:{"src":"static/frames/gammes/index.html","frameborder":"0","scrolling":"auto"}})])
}]

export { render, staticRenderFns }